import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL, SITE_URL, GetRedirectUrl } from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';
import { decrypt } from '../../helpers/encryption';

const Header = () => {
    const path = GetRedirectUrl();
    const [authUser, setAuthUser] = useState({});
    const [themeStyle, setThemeStyle] = useState('light');
    const { isSidebarHidden, setSidebarHidden } = useContext(AppContext);
    const { isToggleActive, setToggleActive } = useContext(AppContext);
    const { SharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();

    useEffect(() => {
        const theme = localStorage.getItem('theme');
        if (theme) {
            if (theme === 'dark') {
                const cssLink = document.getElementById('dark-css');
                if (cssLink) {
                    cssLink.href = `${process.env.PUBLIC_URL}/assets/css/dark.css`;
                }
                setThemeStyle('dark');
            } else {
                const cssLink = document.getElementById('dark-css');
                if (cssLink) {
                    cssLink.href = '#';
                }
                setThemeStyle('light');
            }
        }
    }, []); // Add an empty dependency array to ensure this effect runs only once

    useEffect(() => {
        const auth_user = decrypt('__bs_auth_user');
        if (Object.keys(SharedAuthUser).length > 0) {
            setAuthUser(SharedAuthUser);
        } else if (auth_user) {
            setAuthUser(auth_user);
        } else {
            setAuthUser({});
        }
    }, [SharedAuthUser]);

    const handleClick = () => {
        setSidebarHidden(!isSidebarHidden);
        setToggleActive(!isToggleActive);
    };

    const handleTheme = (theme) => {
        localStorage.setItem('theme', theme);
        if (theme === 'dark') {
            const cssLink = document.getElementById('dark-css');
            if (cssLink) {
                cssLink.href = `${process.env.PUBLIC_URL}/assets/css/dark.css`;
            }
            setThemeStyle('dark');
        } else {
            const cssLink = document.getElementById('dark-css');
            if (cssLink) {
                cssLink.href = '#';
            }
            setThemeStyle('light');
        }
    };

    const logout = () => {
        localStorage.removeItem('__bs_auth_user');
        navigate(`${INDEX_URL}`);
    }

    return (
        <React.Fragment>
            {((path !== 'login' && path !== 'sign-up') && path !== '' && path !== null) && (
                <React.Fragment>
                    <header className={`cx-header ${isSidebarHidden ? 'sb-hide' : ''}`}>
                        <div className="cx-header-items">
                            <div className="left-header">
                                <a
                                    href="#"
                                    onClick={handleClick}
                                    className={`cx-toggle-sidebar ${isToggleActive ? 'active-toggle' : ''}`}
                                >
                                    <span className="outer-ring">
                                        <span className="inner-ring"></span>
                                    </span>
                                </a>
                                <div className="header-search-box">
                                    <div className="header-search-drop">
                                        <a href="#" className="open-search">
                                            <i className="ri-search-line"></i>
                                        </a>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="right-header">
                                <div className="cx-header-logo">
                                    <img
                                        src="/webchat/assets/image/full-logo-dark.png"
                                        alt="logo"
                                        className="dark-logo"
                                    />
                                    <img
                                        src="/webchat/assets/image/full-logo.png"
                                        alt="logo"
                                        className="white-logo"
                                    />
                                </div>
                                <div className="inner-right-header">
                                    <div className="cx-right-tool display-dark">
                                        <a
                                            className="cx-mode dark"
                                            href="#"
                                            onClick={() => handleTheme('dark')}
                                            style={{ display: themeStyle === 'dark' ? 'none' : 'flex' }}
                                        >
                                            <i className="ri-moon-clear-line"></i>
                                        </a>
                                        <a
                                            className="cx-mode light"
                                            href="#"
                                            onClick={() => handleTheme('light')}
                                            style={{ display: themeStyle === 'dark' ? 'flex' : 'none' }}
                                        >
                                            <i className="ri-sun-line"></i>
                                        </a>
                                    </div>
                                    <div className="cx-right-tool cx-user-drop">
                                        <div className="cx-hover-drop">
                                            <div className="cx-hover-tool">
                                                <img
                                                    className="user"
                                                    src={`${process.env.PUBLIC_URL}/assets/image/profile.png`}
                                                    alt="user"
                                                />
                                            </div>
                                            <div className="cx-hover-drop-panel right">
                                                <div className="details">
                                                    <h6>
                                                        {authUser &&
                                                            `${authUser.first_name || ''} ${
                                                                authUser.last_name || ''
                                                            }`}
                                                    </h6>
                                                    <p>{authUser && authUser.email}</p>
                                                </div>
                                                <ul className="border-top">
                                                    <li>
                                                        <Link to={`${INDEX_URL}profile`}>Profile</Link>    
                                                    </li>
                                                    <li>
                                                        <Link to={`${INDEX_URL}wa-settings`}>WhatsApp Settings</Link>    
                                                    </li>
                                                </ul>
                                                <ul className="border-top">
                                                    <li>
                                                        <Link to={`${INDEX_URL}`} onClick={() => logout()}><i className="ri-logout-circle-r-line"></i>Logout</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default Header;